<div class="lib">
  <header class="lib-head">
    <div class="lib-wrap">
      <nav class="lib-crumb" aria-label="Breadcrumb">
        <a routerLink="/blog">Insights &amp; Opinion</a>
        <span aria-hidden="true">/</span>
        <span>Market Guides</span>
      </nav>
      <p class="lib-eyebrow">PlateX Market Guides</p>
      <h1 class="lib-title">Market Guides</h1>
      <p class="lib-intro">
        Standalone publications from PlateX: original research into how the UK registration market works, drawn from
        recorded sales.
      </p>
    </div>
  </header>

  <section class="lib-wrap lib-list">
    <p *ngIf="state === 'loading'" class="lib-note" aria-live="polite">Loading guides…</p>
    <p *ngIf="state === 'error'" class="lib-note">The guides could not be loaded. Please try again shortly.</p>
    <p *ngIf="state === 'ready' && !guides.length" class="lib-note">The first guide is on its way.</p>

    <a class="lib-card" *ngFor="let g of guides" [routerLink]="path(g.slug)">
      <img class="lib-cover" [src]="g.coverUrl" [alt]="'Cover of ' + g.title" width="240" height="339" loading="lazy" />
      <div class="lib-card-body">
        <p class="lib-issue">
          <span *ngIf="g.issueLabel">{{ g.issueLabel }}</span><span *ngIf="g.edition"> · {{ g.edition }}</span>
        </p>
        <h2 class="lib-card-title">{{ g.title }}</h2>
        <p class="lib-card-sub">{{ g.subtitle }}</p>
        <p class="lib-card-desc">{{ g.landing?.standfirst || g.description }}</p>
        <p class="lib-status" *ngIf="status(g) as s">{{ s }}</p>
        <span class="lib-more">View the guide ›</span>
      </div>
    </a>
  </section>
</div>
